module.exports = __webpack_public_path__ + "assets/img/4.0b62786a.png";